module.exports = __webpack_public_path__ + "static/media/septic-repair.03cf844b.jpg";